import React, { Component } from 'react';
import upPict from '../../assets/up.png';
import downPict from '../../assets/down.png';
import commentPict from '../../assets/comment.svg';
import viewPict from '../../assets/view.svg';
import moment from 'moment';

export default ({listForum, handleGetById, handleVote}) => {
    return (
      <div className="col-lg-9 col-md-8 col-sm-12 col-12">
        <div className="card card-forum">
          <div className="card-header">Topik Trending</div>
          <div className="card-body" style={{fontSize: '13px'}}>
            {
              listForum.length ? listForum.map(e => {
                return (
                  <div className="card card-primary mb-4">
                    <div className="card-body">
                      <table className="table-borderless w-100">
                        <tr>
                          <td className="pr-4 d-lg-block d-md-none d-sm-none d-none" valign="top">
                            <table className="table-borderless w-100">
                              <tr>
                                <td>
                                  <div className="circle" style={{width: '53px', height: '53px', padding: '15px', color: '#0085C7', fontSize: '18px', fontWeight: '600', cursor: 'pointer'}} onClick={() => handleVote({refId: e._id})}>
                                    {e.votesData.length}
                                  </div>
                                </td>
                                <td>
                                  <div className="ml-3"><a href=""><img className="mb-2" src={upPict} alt="up" style={{width: '13px', height: '13px'}} /></a><br /><a href=""><img src={downPict} alt="down" style={{width: '13px', height: '13px'}} /></a></div>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td valign="top">
                            <p style={{fontSize: '16px', fontWeight: '600'}}>{e.title}</p>
                            <p className="text-muted" style={{fontSize: '12px'}}>{moment(e.createdAt).format('DD MMM YYYY HH:mm')} <a href="">{(e.author.split('|'))[0]} </a> Buka Topik</p>
                          </td>
                        </tr>
                        <tr>
                          <td className="d-lg-block d-md-none d-sm-none d-none" style={{fontSize: '12px',paddingTop: '20px'}}>
                            <p style={{color: '#0085C7', marginLeft: '10px'}}>{e.votesData.length} Vote</p>
                          </td>
                          <td style={{fontSize: '12px',paddingTop: '20px'}}>
                            <div className="space-between" style={{flexWrap: 'wrap'}}><a href="" style={{color: 'black'}}><img className="mr-2" src={commentPict} alt="comment" style={{width: '12px', height: '12px'}} /><span> {e.commentsData.length} Respon</span></a>
                              <p><img className="mr-2" src={viewPict} alt="view" style={{width: '12px', height: '12px'}} /><span> Dilihat {e.viewer} kali</span></p><a href="" style={{color: '#0085C7'}}>{e.category}</a>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <div className="d-lg-none d-md-block d-sm-block d-block mt-4">
                        <table className="table-borderless w-100">
                          <tr>
                            <td>
                              <table className="table-borderless">
                                <tr>
                                  <td>
                                    <div className="circle" style={{width: '53px', height: '53px', padding: '15px', color: '#0085C7', fontSize: '18px', fontWeight: '600'}}>
                                      {e.votesData.length}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="ml-3"><a href=""><img className="mb-2" src={upPict} alt="up" style={{width: '13px', height: '13px'}} /></a><br /><a href=""><img src={downPict} alt="down" style={{width: '13px', height: '13px'}} /></a></div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td>
                              <p className="mb-0" style={{color: '#0085C7', fontSize: '13px'}}>{e.votesData.length} Vote</p>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                )
              }) : (
                <div className="card card-primary mb-4">
                  <div className="card-body">
                    Belum ada forum yang dibuat, silahkan ajukan forum yang anda butuhkan
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
}
